// Read more: https://kit.svelte.dev/docs/load
import { preloadBlocks } from '$lib/components/Blocks/map';
import { appendDomainQueryParam } from '$lib/utils/appendDomainQueryParam';
import { extractComponentTypes } from '$lib/utils/extractComponentTypes';
import { getDataBaseUrl } from '$lib/utils/getDataBaseUrl';
import { isFunBrandsEnabled } from '$lib/utils/isFunBrandsEnabled';

import debug from 'debug';

import type { PageLoad } from './$types';

const debugLog = debug('routes:[slug]:+page.js');

export const load: PageLoad = async ({ params, fetch }) => {
    const dataBasePath = getDataBaseUrl();
    const res = await fetch(
        `${dataBasePath}/pages/${params.slug}.json?v=${
            window.campaignVersionId
        }${appendDomainQueryParam()}`,
    );
    const pageData = await res.json();

    // TODO: Remove once Theming 2.0 is fully migrated
    if (isFunBrandsEnabled(pageData)) {
        pageData.theme = pageData.themeV2;
    }

    // Preload block components needed by this page that aren't already cached.
    // On the initial page load these are covered by window.__BLOCK_TYPES__,
    // but on navigation the target page may use blocks not yet imported.
    await preloadBlocks(extractComponentTypes(pageData));

    debugLog('-> load', pageData);

    return pageData;
};
